import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6.44 10.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M7.19 4.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M13.19 3.333a2 2 0 0 0-2-2h-6a2 2 0 0 0-2 2v9.334a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2zm-1.528 9.805a.67.67 0 0 0 .196-.471V8H4.524v4.667a.667.667 0 0 0 .667.666h6c.177 0 .346-.07.471-.195M4.524 6.667h7.334V3.333a.667.667 0 0 0-.667-.666h-6a.667.667 0 0 0-.667.666z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })